import React from 'react';

import * as S from './NoDetails.styles';

const NoDetails = ({ icon, heading, cta }) => {

  const bookNowClick = () => {
    window.open('https://www.makemytrip.com/flights/?action=smartbuy&open=browser', '_self');
  }

  return (
    <S.NoDtl>
      {icon && <S.NoDtlIcon><img src={icon} alt="" /></S.NoDtlIcon>}
      {heading && <S.NoDtlHdng>{heading}</S.NoDtlHdng>}
      {cta && <S.NoDtlCta onClick={bookNowClick}>{cta}</S.NoDtlCta>}
    </S.NoDtl>
  )
}

export default NoDetails;